import { createSlice } from "@reduxjs/toolkit";

const initialHlpcDashboardState = {
  listLoading: false,
  actionsLoading: false,
  entities: {
    mahasiswa: {
      date_range: {
        start: null,
        end: null
      },
      total_by_category: {
        PSB: {
          total: 0,
          done: 0,
          waiting_or_inprogress: 0,
          average_duration_seconds: 0,
          average_duration_human: null
        },
        Gangguan: {
          total: 0,
          done: 0,
          waiting_or_inprogress: 0,
          average_duration_seconds: 0,
          average_duration_human: null
        }
      },
      daily_ticket_counts: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      daily_psb: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      daily_gangguan: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      }
    },
    residential: {
      date_range: {
        start: null,
        end: null
      },
      total_by_category: {
        PSB: {
          total: 0,
          done: 0,
          waiting_or_inprogress: 0,
          average_duration_seconds: 0,
          average_duration_human: null
        },
        Gangguan: {
          total: 0,
          done: 0,
          waiting_or_inprogress: 0,
          average_duration_seconds: 0,
          average_duration_human: null
        }
      },
      daily_ticket_counts: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      daily_psb: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      daily_gangguan: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      }
    },
  },
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const hlpcDashboardSlice = createSlice({
  name: "hlpcDashboard",
  initialState: initialHlpcDashboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    hlpcDashboardFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
    },
  },
});
